import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60e4f7ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product__count-info" }
const _hoisted_2 = { class: "count-info__wrapper" }
const _hoisted_3 = { class: "count-info__wrapper--stock" }
const _hoisted_4 = { class: "count-info__wrapper--control" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "count-info__wrapper--single-price" }

import { toRefs } from 'vue';
import { useCart } from '@/store';
import { ICartItem } from '@/store/cart/_types';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartProductCountInfo',
  props: {
    item: null,
    isHovered: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  item: ICartItem;
  isHovered: boolean;
};



const { product } = toRefs(props.item);
const { decrementCount, incrementCount, dropProduct, updateCount } = useCart();

const updateInput = ({ target }: Event): void => {
  if (target instanceof HTMLInputElement) {
    updateCount(target.value, product.value['id']);
  }
};

const limitStock = ({ target }: Event): void => {
  if (target instanceof HTMLInputElement) {
    const valNumber = Number(target.value);

    if (valNumber > product.value['stock']) {
      target.value = String(product.value['stock']);
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass([{ active: props.isHovered }, "delete"]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(dropProduct)(_unref(product).id)))
    }, [
      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-trash" })
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "Stock: " + _toDisplayString(_unref(product).stock) + "pc.", 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "decrement",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(decrementCount)(_unref(product).id)))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-minus" })
        ]),
        _createElementVNode("input", {
          onInput: limitStock,
          type: "number",
          class: "count",
          value: __props.item.count,
          onChange: updateInput
        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5),
        _createElementVNode("button", {
          disabled: __props.item.count === _unref(product).stock,
          class: "increment",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(incrementCount)(__props.item.product.id)))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-plus" })
        ], 8 /* PROPS */, _hoisted_6)
      ]),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(product).actualPrice.toFixed(2)) + "$/pc.", 1 /* TEXT */)
    ])
  ]))
}
}

})